import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Text from "components/Text";
import crossIcon from "assets/images/cross.svg";
import { useAllStaffByDesignationIdAndOfficeId } from "repositories/notes-repository";
import Loader from "components/Loader";
import ReportsToCheckboxes from "../components/ReportsToCheckBoxes";

function ReportsToSelectionModal({
  t,
  isModalOpen,
  setIsModalOpen,
  selectedReportsToStaff,
  selectReportToStaffMember,
  officeId,
  ownerId,
  globalStaffPage,
}) {
  const [memberListSearch, setMemberListSearch] = useState("");
  const [selectedVal, setSelectedVal] = useState(
    selectedReportsToStaff || null
  );
  const { data, isLoading } = useAllStaffByDesignationIdAndOfficeId(
    [],
    officeId,
    {
      ownerId,
      IsOwnerInclude: true,
      includeAdminOffice: true,
      isDistinct: true,
    },
    {
      enabled: globalStaffPage ? officeId?.length > 0 && !!ownerId : !!ownerId,
    }
  );
  const onSearch = (val) => {
    setMemberListSearch(val);
  };
  const memberList = useMemo(() => {
    if (globalStaffPage && (officeId?.length === 0 || !ownerId)) {
      return [];
    }
    const trimSearch = memberListSearch.trim().toLowerCase();
    if (trimSearch.length && data?.data?.length) {
      return (
        data?.data.filter((item) => {
          const fullName =
            `${item?.user?.firstName}${item?.user?.lastName}`.toLowerCase();
          return fullName.includes(trimSearch);
        }) || []
      );
    }
    return data?.data || [];
  }, [memberListSearch, data?.data]);
  return (
    <>
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        className={"modal-dialog-centered modal-width-660"}
        modalClassName="custom-modal"
      >
        <span className="close-btn" onClick={() => setIsModalOpen(false)}>
          <img src={crossIcon} alt="close" />
        </span>
        <ModalBody>
          <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
            <span className="modal-title-25">Reports To</span>
          </Text>
          {isLoading && <Loader />}
          <ReportsToCheckboxes
            memberList={memberList}
            setSelectedVal={setSelectedVal}
            selectedVal={selectedVal}
            memberListSearch={memberListSearch}
            onSearch={onSearch}
            modalOpened
          />
          <button
            className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
            title={t("apply")}
            onClick={() => {
              selectReportToStaffMember({
                ReportToId: selectedVal,
              });
              setIsModalOpen(false);
              setSelectedVal(null);
            }}
          >
            {t("apply")}
          </button>
          <button
            className="button button-round button-border button-dark btn-mobile-link "
            onClick={() => {
              setIsModalOpen(false);
              setSelectedVal(null);
            }}
            title={t("cancel")}
          >
            {t("cancel")}
          </button>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(ReportsToSelectionModal);
